/** Public admin web origin — used for checkout → QR auth and QR code URLs. */
export const getWebOrigin = () => {
  const fromEnv = process.env.REACT_APP_WEB_ORIGIN || process.env.REACT_WEB;
  if (fromEnv) {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'http://localhost:3000';
};

export const getAuthenticatorUrl = (search = '') => {
  const base = `${getWebOrigin()}/Authenticatior`;
  if (!search) {
    return base;
  }
  return search.startsWith('?') ? `${base}${search}` : `${base}?${search}`;
};
